/** Sheet drag — pure release decisions and finger resistance (§4.3). */
export const SHEET_MIN_DISMISS_PX = 72;
export const SHEET_FLICK_PX_PER_MS = 0.6;
const DISMISS_SHARE = 0.25;
const UPWARD_RESISTANCE = 0.2;

export function sheetDragThresholdPx(height: number): number {
  return Math.max(SHEET_MIN_DISMISS_PX, height * DISMISS_SHARE);
}
export function sheetDragAction(offset: number, height: number, velocity: number): "dismiss" | "settle" {
  return offset >= sheetDragThresholdPx(height) || (offset > 0 && velocity >= SHEET_FLICK_PX_PER_MS)
    ? "dismiss" : "settle";
}
export function sheetDragOffset(offset: number): number {
  return offset < 0 ? offset * UPWARD_RESISTANCE : offset;
}
